import Dropdown from "../Dropdown";
import Descreption from "../Descreption"; /* .. means one step back in folder and . means in the current folder*/
import Content from "../Content";
import Signup from "../Signup";
import Footer from "../Footer";
import Navbar from "../Navbar";

export default function HomePage(){
    return(
<div>
    <Navbar />
<Descreption />
       <Dropdown />
       <Content />
       <Signup />
       <Footer />

</div>

    )


}